import React, { useState } from "react";
import PropTypes from "prop-types";
import { LockKeyhole } from "lucide-react";

import Alert from "./Alert";
import Button from "./Button";
import FormField from "./FormField";
import PasswordInput from "./PasswordInput";
import TextInput from "./TextInput";
import WSMLogo from "./WSMLogo";

const LoginScreen = ({ error, loading = false, onForgotPassword, onSubmit }) => {
  const [values, setValues] = useState({ username: "", password: "" });

  const submit = (event) => {
    event.preventDefault();
    onSubmit(values);
  };

  return (
    <main className="wsm-login">
      <section className="wsm-login__brand" aria-labelledby="login-product-name">
        <div className="wsm-login__brand-inner">
          <span className="wsm-login__mark"><WSMLogo /></span>
          <p className="wsm-login__suite">RailHub</p>
          <h1 id="login-product-name">Worksite Manager</h1>
          <p>Plan, manage and review railway worksite packs in one secure workspace.</p>
        </div>
        <p className="wsm-login__support">Authorised users only</p>
      </section>

      <section className="wsm-login__form-section" aria-labelledby="login-heading">
        <form className="wsm-login__form" noValidate onSubmit={submit}>
          <div className="wsm-login__heading">
            <span className="wsm-login__heading-icon"><LockKeyhole aria-hidden="true" /></span>
            <div><h2 id="login-heading">Sign in</h2><p>Use your RailHub account to continue.</p></div>
          </div>

          {error && <Alert title="Unable to sign in" type="error">{error}</Alert>}

          <FormField id="login-username" label="Email or username" required>
            {(fieldProps) => (
              <TextInput
                {...fieldProps}
                autoComplete="username"
                disabled={loading}
                name="username"
                onChange={(event) => setValues((current) => ({ ...current, username: event.target.value }))}
                value={values.username}
              />
            )}
          </FormField>

          <FormField id="login-password" label="Password" required>
            {(fieldProps) => (
              <PasswordInput
                {...fieldProps}
                autoComplete="current-password"
                disabled={loading}
                name="password"
                onChange={(event) => setValues((current) => ({ ...current, password: event.target.value }))}
                value={values.password}
              />
            )}
          </FormField>

          <button className="wsm-login__forgot" disabled={loading} onClick={onForgotPassword} type="button">Forgot your password?</button>
          <Button fullWidth loading={loading} loadingLabel="Signing in..." type="submit">Sign in</Button>
          <p className="wsm-login__privacy">Access is monitored and subject to the RailHub terms of use.</p>
        </form>
      </section>
    </main>
  );
};

LoginScreen.propTypes = {
  error: PropTypes.string,
  loading: PropTypes.bool,
  onForgotPassword: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
};

export default LoginScreen;
